import { Table } from 'react-bootstrap';
import { useContext } from 'react';
import StartNumbersContext from '../../../../contexts/StartNumbersContext';
import StartNumbersRow from './StartNumbersRow';

const StartNumbersTable = () => {
  const { startNumberGroups } = useContext(StartNumbersContext);
  return (
    <Table
      style={{
        borderCollapse: 'separate',
        borderSpacing: '0 0.5rem',
        width: '100%',
      }}
      className='table-borderless'
    >
      <thead className='bg-divider'>
        <tr>
          <th style={{ width: 'auto' }}>Klass</th>
          <th style={{ width: '10%', textAlign: 'center' }}>Deltagare</th>
          <th style={{ width: '20%', textAlign: 'center' }}>
            Lägsta startnummer
          </th>
          <th style={{ width: '15%', textAlign: 'center' }}>
            Till nästa klass
          </th>
          <th style={{ width: '44px' }}></th>
        </tr>
      </thead>
      <tbody>
        {startNumberGroups.map((group) => (
          <StartNumbersRow key={group.id} data={group} />
        ))}
      </tbody>
    </Table>
  );
};

export default StartNumbersTable;
